/**
 * Turn API enum-style labels (e.g. `TO_DO`, `IN_PROCESS`) into readable text (`To Do`, `In Progress`).
 * Splits on underscores and whitespace, title-cases each token.
 * @param {unknown} raw
 * @returns {string}
 */
export function formatEnumLabelForDisplay(raw) {
  if (raw == null) return "";
  const s = String(raw).trim();
  if (!s) return "";
  const normalizedKey = s
    .toUpperCase()
    .replace(/[_\s]+/g, "_")
    .replace(/^_+|_+$/g, "");
  /** Product copy: treat legacy `IN_PROCESS` the same as in-progress status. */
  if (normalizedKey === "IN_PROCESS") return "In Progress";
  if (normalizedKey === "NEW" || normalizedKey === "TODO" || normalizedKey === "TO_DO")
    return "New";
  return s
    .split(/[_\s]+/)
    .filter(Boolean)
    .map((part) => {
      const lower = part.toLowerCase();
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join(" ");
}
